import gql from 'graphql-tag';

export class RecipientMutations {
  static createRecipientMutation = gql`
    mutation CreateRecipient($documentId: String!, $contactId: String!, $role: RoleType) {
      createRecipient(documentId: $documentId, contactId: $contactId, role: $role) {
        id
        firstName
        lastName
        fullName
        companyName
        companyNumber
        title
        mobile
        email
        thumbUrl
        gender
        role
        orderNum
        verifyEid
        verifyEidType
        verifyLinkedin
        verifyQna
        verifySms
      }
    }
  `;

  static deleteRecipientMutation = gql`
    mutation DeleteRecipient($id: String!) {
      deleteRecipient(id: $id)
    }
  `;

  static updateRecipientMutation = gql`
    mutation UpdateRecipientV2(
      $documentId: String!
      $id: String!
      $contactId: String
      $role: String
      $roleName: String
      $status: String
      $orderNum: Int
      $firstName: String
      $lastName: String
      $companyId: String
      $companyName: String
      $companyNumber: String
      $title: String
      $phone: String
      $mobile: String
      $email: String
      $thumbUrl: String
      $note: String
      $gender: String
      $verifyQna: Boolean
      $verifyQnaOpen: Boolean
      $verifyQnaSign: Boolean
      $verifyQnaQuestion: String
      $verifyQnaAnswer: String
      $verifySms: Boolean
      $verifySmsOpen: Boolean
      $verifySmsSign: Boolean
      $verifySmsNumber: String
      $verifySmsCode: String
      $verifyLinkedin: Boolean
      $verifyEid: Boolean
      $verifyEidType: EIdSignType
      $verifyEidNumber: String
      $settings: RecipientSettings
    ) {
      updateRecipientV2(
        documentId: $documentId
        id: $id
        contactId: $contactId
        role: $role
        roleName: $roleName
        status: $status
        orderNum: $orderNum
        firstName: $firstName
        lastName: $lastName
        companyId: $companyId
        companyName: $companyName
        companyNumber: $companyNumber
        title: $title
        phone: $phone
        mobile: $mobile
        email: $email
        thumbUrl: $thumbUrl
        note: $note
        gender: $gender
        verifyQna: $verifyQna
        verifyQnaOpen: $verifyQnaOpen
        verifyQnaSign: $verifyQnaSign
        verifyQnaQuestion: $verifyQnaQuestion
        verifyQnaAnswer: $verifyQnaAnswer
        verifySms: $verifySms
        verifySmsOpen: $verifySmsOpen
        verifySmsSign: $verifySmsSign
        verifySmsNumber: $verifySmsNumber
        verifySmsCode: $verifySmsCode
        verifyLinkedin: $verifyLinkedin
        verifyEid: $verifyEid
        verifyEidType: $verifyEidType
        verifyEidNumber: $verifyEidNumber
        settings: $settings
      )
    }
  `;

  static updateRecipientOrderMutation = gql`
    mutation UpdateRecipientOrder($documentId: String!, $recipientOrder: [RecipientOrderInput!]!) {
      updateRecipientOrder(documentId: $documentId, recipientOrder: $recipientOrder) {
        id
      }
    }
  `;
}
